export enum VerbalBoolean {
  Yes = "Yes",
  No = "No",
}

export enum API_ERROR {
  DEFAULT = "Something went wrong please try again or contact support",
  PROFILE_FIELDS = "Error in one of your profile fields",
}
